/**
 * 医技API
 */
export default {
  treatmentApi: {
    getYJTreatments: '/treatment-api/webapi/yj-treatment/get-yj-treatments',                               // 获取医技订单列表
    getYJTreatmentDetails: '/treatment-api/webapi/yj-treatment/get-yj-treatment-details-and-result',       // 获取一条医技订单的所有明细
    uploadYJTreatmentResults: '/treatment-api/webapi/yj-treatment-result/upload-yj-treatment-results',     // 上传医技订单明细的检查报告
    deleteTreatmentResult: '/treatment-api/webapi/yj-treatment-result/delete-treatment-result',            // 删除检查结果图片
    getTreatmentResultImage: '/treatment-api/webapi/yj-treatment-result/get-treatment-result-image',       // 获取检查结果图片
    getTreatmentResultThumb: '/treatment-api/webapi/yj-treatment-result/get-treatment-result-image-thumb', // 获取检查结果缩略图
    makeSureSchedule: '/treatment-api/webapi/yj-treatment/make-sure-schedule',                             // 确定排期
    getYJTreatmentRemarks: '/treatment-api/webapi/yj-treatment-remark/get-yj-treatment-remarks',           // 获取所有诊疗项的检查须知集合
    editYJTreatmentRemark: '/treatment-api/webapi/yj-treatment-remark/edit-yj-treatment-remark',           // 新增或者更新一条诊疗项的检查须知
    sendNotice: '/treatment-api/webapi/yj-treatment/yj-treatment-status-report-comed',                     // 上传医技订单明细的检查报告后通知病人
    makeSureTreated: '/treatment-api/webapi/yj-treatment/make-sure-treated',                               // 已检查
    yjTreatmentStatusReportComed: '/treatment-api/webapi/yj-treatment/yj-treatment-status-report-comed',   // 已出报告
    makeSureYjTreatmentReturn: '/treatment-api/webapi/yj-treatment/make-sure-yj-treatment-return',         // 确定退医技项目（即组套）（注意：只针对门诊，先不支持住院） POST
    getYjTreatmentsForReturn: '/treatment-api/webapi/yj-treatment/get-yj-treatments-for-return'            // 根据流水号serial_number获取某个病人的医技项目（即组套）列表，用于退医技（注意：只针对门诊，先不支持住院） GET
  }
}
